/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Eye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Eye"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M15.545 12c0 1.933-1.587 3.5-3.545 3.5S8.455 13.933 8.455 12 10.042 8.5 12 8.5s3.545 1.567 3.545 3.5m-1.772 0c0 .966-.794 1.75-1.773 1.75-.98 0-1.773-.784-1.773-1.75s.794-1.75 1.773-1.75 1.773.784 1.773 1.75"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M21.38 10.213a2.884 2.884 0 0 1 0 3.575c-5.472 6.95-13.288 6.95-18.76 0a2.885 2.885 0 0 1 0-3.576c5.472-6.95 13.288-6.95 18.76 0m-1.4 2.501c-2.487 3.159-5.333 4.536-7.98 4.536s-5.493-1.378-7.98-4.536a1.15 1.15 0 0 1 0-1.428C6.508 8.127 9.354 6.75 12 6.75s5.493 1.378 7.98 4.536c.33.42.33 1.008 0 1.428"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const EyeIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'eye-icon'}
      icon={Eye}
      {...props}
      size={size}
    />
  );
};
